// import UserService from "@/services/User/UserService";

const state = {
  data: {
    company: '',
    country: '',
    month_of_processing: '',
    composition: '',
    gross_volume: '',
    net_volume: '',
    volume_units: '%',
    contamination: '',
    comments: ''
  }
};

const actions = {
  setData({commit}, data) {
    commit('setData', data);
  }
};

const mutations = {
  setData(state, data) {
    state.data = data;
  }
};

const getters = {
  data(state) {
    return state.data;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
